import React, {createContext, useReducer} from 'react'

export const SET_TEST_ZONE_LIST = 'SET_TEST_ZONE_LIST'
export const SELECT_TEST_ZONE = 'SELECT_TEST_ZONE'
export const SET_SHOW_TEST_ZONE_POPUP = 'SET_SHOW_TEST_ZONE_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_TEST_ZONE_LIST:
      return { ...data, test_zone_list: payload.data }
    case SELECT_TEST_ZONE:
      return {
        ...data,
        selected_test_zone: payload.data.selected_test_zone,
        show_test_zone_popup: payload.data.show_test_zone_popup,
      }
    case SET_SHOW_TEST_ZONE_POPUP:
      return {
        ...data,
        show_test_zone_popup: payload.data,
        selected_test_zone: payload.data ? data.selected_test_zone : {},
      }
    default:
      return data
  }
}

const initialState = {
  test_zone_list: [],
  selected_test_zone: {},
  show_test_zone_popup: false,
}

const TestZoneStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <TestZoneContext.Provider value={[state, dispatch]}>
      {children}
    </TestZoneContext.Provider>
  )
}

export const TestZoneContext = createContext(initialState)
export default TestZoneStore
